import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { FontManager } from '@/model/fontManager/fontManager';

// テキストの文法情報
export class TextInfo
{
    // フォントId
    public fontId : string = FontManager.DEFAULT_FONT_ID;
    // フォントサイズ(pt)
    public fontSize : number = 14;
    // テキストカラー
    public textColor : ColorConstruct = new ColorConstruct();
    // 字間(pt)
    public letterSpacing : number = 0;
    // 太字
    public bold : boolean = false;
    // 斜体
    public italic : boolean = false;
    // 下線
    public underline : boolean = false;
    // 文字幅
    public letterWidth : number = 100;
    // 縦中横
    public isHorizontalInVertical : boolean = false;
    // 全角
    public isEmQuad : boolean = false;
    // 影表示フラグ
    public isShadow : boolean = false;
    // 影色
    public shadowColor : ColorConstruct = new ColorConstruct(102, 102, 102);
    // 影距離(%)
    public shadowDistance : number = 10;
    // 影角度
    public shadowRotate : number = 45;
    // 影ぼかし(%)
    public shadowBlur : number = 50;
    // 影強さ(%)
    public shadowIntensity : number = 50;
    // 縁
    public isOutline : boolean = false;
    // 縁色
    public outlineColor : ColorConstruct = new ColorConstruct(255, 102, 0);
    // 縁太さ(%)
    public outlineThickness : number = 50;
    // 縁強さ(%)
    public outlineIntensity : number = 50;

    public clone() : TextInfo
    {
        var textInfo = new TextInfo();
        textInfo.fontId = this.fontId;
        textInfo.fontSize = this.fontSize;
        textInfo.textColor = this.textColor.clone();
        textInfo.letterSpacing = this.letterSpacing;
        textInfo.bold = this.bold;
        textInfo.italic = this.italic;
        textInfo.underline = this.underline;
        textInfo.letterWidth = this.letterWidth;
        textInfo.isHorizontalInVertical = this.isHorizontalInVertical;
        textInfo.isEmQuad = this.isEmQuad;
        textInfo.isShadow = this.isShadow;
        textInfo.shadowColor = this.shadowColor.clone();
        textInfo.shadowDistance = this.shadowDistance;
        textInfo.shadowRotate = this.shadowRotate;
        textInfo.shadowBlur = this.shadowBlur;
        textInfo.shadowIntensity = this.shadowIntensity;
        textInfo.isOutline = this.isOutline;
        textInfo.outlineColor = this.outlineColor.clone();
        textInfo.outlineThickness = this.outlineThickness;
        textInfo.outlineIntensity = this.outlineIntensity;
        return textInfo;
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            fontId : this.fontId,
            fontSize : this.fontSize,
            textColor : this.textColor,
            letterSpacing : this.letterSpacing,
            bold : this.bold,
            italic : this.italic,
            underline : this.underline,
            letterWidth : this.letterWidth,
            isHorizontalInVertical : this.isHorizontalInVertical,
            isEmQuad : this.isEmQuad,
            isShadow : this.isShadow,
            shadowColor : this.shadowColor,
            shadowDistance : this.shadowDistance,
            shadowRotate : this.shadowRotate,
            shadowBlur : this.shadowBlur,
            shadowIntensity : this.shadowIntensity,
            isOutline : this.isOutline,
            outlineColor : this.outlineColor,
            outlineThickness : this.outlineThickness,
            outlineIntensity : this.outlineIntensity,
        };

        return cloneObj;
    }
    public static createFromJsonData(jsonData : any)
    {
        var textInfo = new TextInfo();
        if(jsonData.fontId != null) 
        {
            var fontId = jsonData.fontId;
            if(!FontManager.isWebFont(jsonData.fontId))
            {
                // ローカルフォントをコンバート
                fontId = FontManager.convertLocalToWebFontIfNeeded(jsonData.fontId);
                if(fontId != jsonData.fontId)
                {
                    // コンバートしたフォントを一時的に保存
                    FontManager.storeUnloadedFontIdIfNew(jsonData.fontId);
                }
            }
            textInfo.fontId = fontId;
        }
        if(jsonData.fontSize != null) { textInfo.fontSize = jsonData.fontSize; }
        if(jsonData.textColor != null) { textInfo.textColor = ColorConstruct.createFromJsonData(jsonData.textColor); }
        if(jsonData.letterSpacing != null) { textInfo.letterSpacing = jsonData.letterSpacing; }
        if(jsonData.bold != null) { textInfo.bold = jsonData.bold; }
        if(jsonData.italic != null) { textInfo.italic = jsonData.italic; }
        if(jsonData.underline != null) { textInfo.underline = jsonData.underline; }
        if(jsonData.letterWidth != null) { textInfo.letterWidth = jsonData.letterWidth; }
        if(jsonData.isHorizontalInVertical != null) { textInfo.isHorizontalInVertical = jsonData.isHorizontalInVertical; }
        if(jsonData.isEmQuad != null) { textInfo.isEmQuad = jsonData.isEmQuad; }
        if(jsonData.isShadow != null) { textInfo.isShadow = jsonData.isShadow; }
        if(jsonData.shadowColor != null) { textInfo.shadowColor = ColorConstruct.createFromJsonData(jsonData.shadowColor); }
        if(jsonData.shadowDistance != null) { textInfo.shadowDistance = jsonData.shadowDistance; }
        if(jsonData.shadowRotate != null) { textInfo.shadowRotate = jsonData.shadowRotate;} 
        if(jsonData.shadowBlur != null) { textInfo.shadowBlur = jsonData.shadowBlur; }
        if(jsonData.shadowIntensity != null) { textInfo.shadowIntensity = jsonData.shadowIntensity; }
        if(jsonData.isOutline != null) { textInfo.isOutline = jsonData.isOutline; }
        if(jsonData.outlineColor != null) { textInfo.outlineColor = ColorConstruct.createFromJsonData(jsonData.outlineColor); }
        if(jsonData.outlineThickness != null) { textInfo.outlineThickness = jsonData.outlineThickness; }
        if(jsonData.outlineIntensity != null) { textInfo.outlineIntensity = jsonData.outlineIntensity; }
        return textInfo;
    }
}